import Stack from '@mui/material/Stack';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from '@/ui';
import { SelectSimple, TimeSelect } from './FormComponents';
import { restrictionTypes } from './constants';
import type { BulkAction } from './types';

const BULK_ACTION_TITLES: Record<BulkAction, string> = {
  all: 'Set All Days',
  weekdays: 'Set Weekdays',
  weekend: 'Set Weekend',
};

interface BulkDayPartingModalProps {
  isOpen: boolean;
  action: BulkAction | null;
  restriction: string;
  startTime: string;
  endTime: string;
  onRestrictionChange: (value: string) => void;
  onStartTimeChange: (value: string) => void;
  onEndTimeChange: (value: string) => void;
  onApply: () => void;
  onCancel: () => void;
}

export function BulkDayPartingModal({
  isOpen,
  action,
  restriction,
  startTime,
  endTime,
  onRestrictionChange,
  onStartTimeChange,
  onEndTimeChange,
  onApply,
  onCancel,
}: BulkDayPartingModalProps) {
  const title = action ? BULK_ACTION_TITLES[action] : 'Bulk Edit';

  return (
    <Modal isOpen={isOpen} toggle={onCancel} centered>
      <ModalHeader toggle={onCancel}>{title}</ModalHeader>
      <ModalBody>
        <Stack spacing={2}>
          <SelectSimple
            label='Restriction'
            value={restriction}
            onChange={onRestrictionChange}
            options={restrictionTypes}
          />
          {restriction === 'Partially Restricted' && (
            <>
              <TimeSelect label='Start Time' value={startTime} onChange={onStartTimeChange} />
              <TimeSelect label='End Time' value={endTime} onChange={onEndTimeChange} />
            </>
          )}
        </Stack>
      </ModalBody>
      <ModalFooter>
        <Button color='secondary' onClick={onCancel}>
          Cancel
        </Button>
        <Button
          color='primary'
          onClick={onApply}
          disabled={restriction === 'Partially Restricted' && (!startTime || !endTime)}
        >
          Apply
        </Button>
      </ModalFooter>
    </Modal>
  );
}
